module.exports = __webpack_public_path__ + "static/media/gasDefault.aefc9a18.png";